module.exports = __webpack_public_path__ + "img/11_71.a4a2967e.png";